/**
 * created by mgg
 * 稿件管理
 */
import React, {Component} from 'react';
import {Tabs, Button, Input, Row, Col, Pagination, Modal} from 'antd';
import "./ManuscriptManagement.css"
import ManagementTable from "../../components/managementTable/ManagementTable";

const {TabPane} = Tabs;
const {Search} = Input;

export default class ManuscriptManagement extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            delVisible: false, //删除
            publishVisible: false, //查看发布
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }


    render() {
        return (
            <div>
                {this.renderHeader()}
                {this.renderPublishModal()}
                {this.renderDelModal()}
            </div>
        )
    };

    //页头
    renderHeader() {
        return (
            <div style={{width: 1640, background: "#fff", opacity: 1, borderRadius: '5', margin: "0 auto"}}>
                <div style={{width: 1575,height: '100%', background: "#fff",margin:"0 auto"}}>
                    <Tabs defaultActiveKey="1" style={{height: 1000}}>
                        <TabPane tab="我提交的稿件" key="1">
                            {this.renderTable()}
                        </TabPane>
                        <TabPane tab="草稿" key="2">
                            {this.renderTable()}
                        </TabPane>
                        <TabPane tab="待处理" key="3">
                            {this.renderTable()}
                        </TabPane>
                        <TabPane tab="已发布" key="4">
                            {this.renderTable()}
                        </TabPane>
                        <TabPane tab="已弃用" key="5">
                            {this.renderTable()}
                        </TabPane>
                    </Tabs>
                    <div>
                    </div>
                </div>
            </div>
        )
    };

    //表格
    renderTable() {
        const columns = [
            {
                title: '序号',
                dataIndex: 'id',
                key: 'id',
                align: 'center',
            },
            {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
                align: 'center',
            },
            {
                title: '创建日期',
                dataIndex: 'createDate',
                key: 'createDate',
                align: 'center',
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                render:(text,record)=>{
                    let color = '';
                    if(record.status === '发布'){
                        color = <div>
                             <span style={{
                                 width: 8,
                                 height: 8,
                                 background:"#F56C6C",
                                 borderRadius: "50%",
                                 opacity: 1
                             }}>
                            </span>
                            <span>发布</span>
                        </div>
                    }else if(record.status === '提交至宣传部'){
                        color = <div>
                             <span style={{
                                 width: 8,
                                 height: 8,
                                 background:"#F56C6C",
                                 borderRadius: "50%",
                                 opacity: 1
                             }}>
                            </span>
                            <span>提交至宣传部</span>
                        </div>
                    }else if(record.status === '草稿'){
                        color = <div>
                             <span style={{
                                 width: 8,
                                 height: 8,
                                 background:"#0050B3",
                                 borderRadius: "50%",
                                 opacity: 1
                             }}>
                            </span>
                            <span>草稿</span>
                        </div>
                    }
                }
            },
            {
                title: '操作',
                dataIndex: 'operation',
                key: 'operation',
                align: 'center',
                render:(text,record)=>(
                    <div>
                        <a type="primary" onClick={()=>this.watch()} style={{marginRight:10}}>查看</a>
                        <a type="primary" onClick={()=>this.watchPublish()} style={{marginRight:10}}>查看发布</a>
                        <a type="primary" onClick={()=>this.edit()} style={{marginRight:10}}>编辑</a>
                        <a type="primary" onClick={()=>this.delete()}>删除</a>
                    </div>
                )
              /*  render:(text,record)=>{
                    let statusText = '';
                    if(record.status === '发布'){
                        statusText = <div>
                            <a type="primary" onClick={()=>this.watch()} style={{marginRight:10}}>查看</a>
                            <a type="primary" onClick={()=>this.watchPublish()}>查看发布</a>
                        </div>
                    }else if(record.status === '草稿'){
                        statusText = <div>
                            <a type="primary" onClick={()=>this.edit()} style={{marginRight:10}}>编辑</a>
                            <a type="primary" onClick={()=>this.delete()}>删除</a>
                        </div>
                    }else{
                        statusText = <div>
                            <a type="primary" onClick={()=>this.watch()} style={{marginRight:10}}>查看</a>
                        </div>
                    }
                }*/
            },
        ];
        const dataSource = [];
        for (let i = 1; i <= 10; i++) {
            dataSource.push(
                {
                    key: i,
                    id: i,
                    title: '稿件管理',
                    createDate: '2021-5-7',
                }
            )
        };
            return (
                <div>
                    <Row style={{marginTop:15}}>
                        <Col span={12}>
                            <Button style={{background:"#0050B3",color:"#fff"}} onClick={()=>{this.write()}}>写稿</Button>
                        </Col>
                        <Col span={12}>
                            <Search placeholder="请输入关键词" onSearch={this.onSearch} style={{width:200,float:"right"}}/>
                        </Col>
                    </Row>
                    <div>
                    <div style={{marginTop:15,height:"1000px"}}>
                        <ManagementTable
                            columns={columns}
                            dataSource={dataSource}
                        />
                    </div>
                   </div>
                </div>
            )
        }

    //删除
    renderDelModal() {
        return (
            <Modal
                title="操作"
                style={{top: 20}}
                visible={this.state.delVisible}
                onOk={() => this.setState({delVisible: false})}
                onCancel={() => this.setState({delVisible: false})}
                centered={true}
                width={400}
                height={200}
                footer={
                    <div style={{textAlign: "center"}}>
                        <Button onClick={() => this.setState({delVisible: false})}>取消</Button>
                        <Button onClick={() => {this.delete()}} style={{background: "#0050B3", color: "#fff"}}>确定</Button>
                    </div>
                }
            >
                <div>确定删除该文章吗？</div>
            </Modal>
        )
    }

    //查看发布
    renderPublishModal() {
        return (
            <Modal
                title="文章链接"
                style={{top: 20}}
                visible={this.state.publishVisible}
                onOk={() => this.setState({publishVisible: false})}
                onCancel={() => this.setState({publishVisible: false})}
                centered={true}
                width={400}
                height={200}
                footer={
                    <div style={{textAlign: "center"}}>
                        <Button onClick={() => this.setState({publishVisible: false})} style={{background: "#0050B3", color: "#fff"}}>关闭</Button>
                    </div>
                }
            >
                <div>
                    <span>新闻网/mp4: </span>
                    <a>点击打开页面</a>
                </div>
            </Modal>
        )
    }

        //页脚
       renderFooter(){
         return(
             <div style={{display: 'flex', justifyContent: "flex-end", marginTop: 20}}>
                 <Pagination defaultCurrent={1} total={50} />
             </div>
         )
       }

    // 写稿
    write() {

    }

    //查看
    watch() {

    }

    //编辑
    edit(){

    }

    //查看发布
    watchPublish(){
      this.setState({
          publishVisible:true,
      })
    }

   // 删除
    delete(){
        this.setState({
            delVisible: true,
        })
    }

}